var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90735e-06 1.00057L1.90735e-06 19.0006C0.000573239 19.1828 0.0508362 19.3614 0.14538 19.5172C0.239924 19.673 0.375167 19.8001 0.536554 19.8848C0.697942 19.9694 0.879362 20.0085 1.06129 19.9977C1.24321 19.9869 1.41874 19.9267 1.569 19.8236L14.569 10.8236C15.108 10.4506 15.108 9.55257 14.569 9.17857L1.569 0.178574C1.41906 0.074399 1.24343 0.0133078 1.06121 0.00193891C0.878981 -0.00943002 0.697124 0.0293578 0.535395 0.114088C0.373665 0.198817 0.238248 0.32625 0.143858 0.482538C0.0494676 0.638826 -0.000285677 0.817994 1.90735e-06 1.00057Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.51540085e2eddc93b29827755b38b34e.svg";
export { ForwardRef as ReactComponent };